
import React, { useEffect, useState } from 'react';
import { BACKARROW_IMG, LOGO_IMG } from '../../../utills/image-constant';
import Inputwithlable from '../../components/common/inputwithlable';
import Loginbtn from '../../components/common/loginbtn';
import { checkValidation, ErrorMessage, ErrorMsg } from '../../../utills/error-message-constant';
import { emailRegex } from '../../../utills/form-regex';
import { adminForgetPassword } from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes/url-constant';

const Forgetpassword = () => {
    const [email, setEmail] = useState();
    const [formError, setFormError] = useState();
    const [forgetbtnLoader, setForgetbtnLoader] = useState(false)
    const [forgetbtndisable, setForgetbtndisable] = useState(true)
    const navigation = useNavigate();

    const handleForgetChange = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.Email,
                emailRegex,
                formError,
                setFormError
            );
        }
        setEmail(value)
    }

    useEffect(() => {
        if (!email || formError?.email) {
            setForgetbtndisable(true);
        } else {
            setForgetbtndisable(false);
        }
    }, [formError, email]);


    const handleForgetPassword = async () => {
        setForgetbtndisable(true);
        setForgetbtnLoader(true)
        try {
            const response = await adminForgetPassword(email);
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
                setForgetbtnLoader(false)
                setForgetbtndisable(false);
            }
            if (response.data?.responseCode === 200) {
                toastEmitter("success", response?.data?.message);
                setForgetbtnLoader(false)
                setForgetbtndisable(true);
                setEmail("")
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
            setForgetbtnLoader(false)
            setForgetbtndisable(false);
        }
    };

    return (
        <>
            <div className="caspera_login_account_content d-flex justify-content-center align-items-center">
                <div class="card forget-div rounded-4 shadow-sm p-5 pt-4 pb-4 border-0">
                    <div class="card-body">
                        <div className='d-flex justify-content-center align-items-center'>
                            <img src={LOGO_IMG} class="img-fluid mb-4 logo_img" alt="..." />
                        </div>
                        <p class="card-text text-center fw-bold fs-4">Forget Password</p>
                        <div class="">
                            <Inputwithlable
                                type="email"
                                name="email"
                                labelName="Email"
                                lableclassName='input-label'
                                className="form-control inputText-lable"
                                placeholder="Enter Email"
                                handleChange={handleForgetChange}
                                value={email}
                                error={formError?.emailStatus}
                            />
                        </div>
                        <div className="mt-2 ms-2"><ErrorMsg error={formError?.email} /></div>
                        <Loginbtn
                            className="submitbtn textfont12 mt-3"
                            handleClick={handleForgetPassword}
                            type="submit"
                            btnName="GET LINK"
                            disablebtn={forgetbtndisable}
                            loader={forgetbtnLoader}
                        />

                        <div className='d-flex justify-content-center align-items-center'>
                            <img className='BackIcon mt-2' src={BACKARROW_IMG} alt='' />
                            <h5 className='text-center ms-1 mt-3 fs-6'>Back to <span className='text-danger cursor-pointer' onClick={() => navigation(ROUTES.ADMINLOGINPAGE)}>Login</span></h5>
                        </div>

                    </div>
                </div>


            </div>

        </>
    )
}

export default Forgetpassword
